import { momentFormat, calcUpload } from '@/utils'
// 线上病历
const columnsOnline = [
  {
    title: '就诊人姓名',
    dataIndex: 'name',
    key: 'name',
    width: 120,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName
    }
  },
  {
    title: '就诊人年龄',
    dataIndex: 'age',
    key: 'age',
    width: 120,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.age
    }
  },
  {
    title: '诊断',
    dataIndex: 'diagnosisInfoList',
    key: 'diagnosisInfoList',
    width: 200,
    slots: { customRender: 'diagnosisInfoList' }
  },
  {
    title: '医生',
    dataIndex: 'doctorName',
    key: 'doctorName',
    width: 100
  },
  {
    title: '科室',
    dataIndex: 'department',
    key: 'department',
    width: 100
  },
  {
    title: '处方',
    dataIndex: 'prescriptionDrug',
    key: 'prescriptionDrug',
    width: 180,
    slots: { customRender: 'prescriptionDrug' }
  },
  {
    title: '创建时间',
    dataIndex: 'createAt',
    key: 'createAt',
    width: 120
  },
  {
    dataIndex: 'id',
    key: 'id',
    title: 'ID',
    width: 120
    // slots: { customRender: 'id' }
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right',
    width: 80
  }
]
// 门诊病历
const columnsOffline = [
  {
    dataIndex: 'id',
    key: 'id',
    title: 'ID',
    width: 240
  },
  {
    title: '就诊人姓名',
    dataIndex: 'patientName',
    key: 'patientName',
    width: 120,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName
    }
  },
  {
    title: '就诊时间',
    dataIndex: 'inquiryTime',
    key: 'inquiryTime',
    width: 130,
    customRender: ({ text }) => {
      return momentFormat(text)
    }
  },
  {
    title: '就诊诊断',
    dataIndex: 'offlineDiagnosis',
    key: 'offlineDiagnosis',
    width: 180,
    slots: { customRender: 'offlineDiagnosis' }
  },
  {
    title: '处方药品',
    dataIndex: 'medicationNames',
    key: 'medicationNames',
    width: 180,
    slots: { customRender: 'medicationNames' }
  },
  {
    title: '开始时间',
    dataIndex: 'beginTime',
    key: 'beginTime',
    width: 180,
    slots: { customRender: 'beginTime' }
  },
  {
    title: '用药周期',
    dataIndex: 'medicineCycle',
    key: 'medicineCycle',
    width: 100,
    slots: { customRender: 'medicineCycle' }
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    width: 180,
    slots: { customRender: 'endTime' }
  },

  // {
  //   title: '是否患者可见',
  //   dataIndex: 'patientPermission',
  //   key: 'patientPermission',
  //   width: 180,
  //   slots: { customRender: 'patientPermission' }
  // },
  {
    title: '上传人',
    dataIndex: 'createBy',
    key: 'createBy',
    width: 150,
    customRender: ({ record }) => {
      return calcUpload(record, 'createBy')
    }
  },
  {
    title: '上传时间',
    dataIndex: 'createAt',
    key: 'createAt',
    width: 180
  },

  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right',
    width: 220
  }
]
// 检查表单
const columnsCheckList = [
  {
    title: '检查单ID',
    dataIndex: 'checklistId',
    key: 'checklistId',
    fixed: 'left',
    width: 120,
    slots: { customRender: 'checklistId' }
  },
  {
    title: '就诊人姓名',
    dataIndex: 'name',
    key: 'name',
    width: 120,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName
    }
  },
  {
    title: '随访计划ID',
    dataIndex: 'adPlanId',
    key: 'adPlanId',
    slots: { customRender: 'adPlanId' },
    width: 120
  },
  // {
  //   title: '表单状态',
  //   dataIndex: 'formStatusString',
  //   key: 'formStatusString',
  //   width: 100
  // },
  {
    title: '推送时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 135
  },

  {
    title: '上传时间',
    dataIndex: 'uploadTime',
    key: 'uploadTime',
    width: 135
  },

  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    fixed: 'right',
    width: 120,
    slots: { customRender: 'handle' }
  }
]
export { columnsOnline, columnsOffline, columnsCheckList }
